import React from "react";
import { Box, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { SFTPStorage } from "../../../../../types/targetStorageTypes";
import { SOCIAL_ACCOUNT_BUTTON_WIDTH } from "../../../../../constants/styles";

const SFTPStorageForm: React.FC<any> = ({ account, mode, onFieldChange, onCreate, onUpdate, onDelete, onChangeMode }) => {
    const sftpAccount = account as SFTPStorage;
    const isReadonly = mode === 'readonly';

    return (
        <Box >
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField fullWidth label="Name" value={sftpAccount.name} disabled={isReadonly} onChange={(e) => onFieldChange('name', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Host" value={sftpAccount.host} disabled={isReadonly} onChange={(e) => onFieldChange('host', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 2 }}>
                    <TextField fullWidth label="Port" type="number" value={sftpAccount.port} disabled={isReadonly} onChange={(e) => onFieldChange('port', Number(e.target.value))} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Remote Path" value={sftpAccount.remote_path} disabled={isReadonly} onChange={(e) => onFieldChange('remote_path', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField fullWidth label="Username" value={sftpAccount.username} disabled={isReadonly} onChange={(e) => onFieldChange('username', e.target.value)} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                        fullWidth
                        label="Password"
                        type="password"
                        value={isReadonly ? (sftpAccount.id ? '********' : '') : (sftpAccount.password || '')}
                        disabled={isReadonly}
                        onChange={(e) => onFieldChange('password', e.target.value)}
                    />
                </Grid>
            </Grid>
            <Box sx={{ mt: 2, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                {isReadonly ? (
                    <>
                        <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<DeleteIcon />} onClick={onDelete}>Delete</Button>
                        <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<EditIcon />} onClick={() => onChangeMode('updatable')}>Edit</Button>
                    </>
                ) : (
                    <>
                        {sftpAccount.id && <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<CloseIcon />} onClick={() => onChangeMode('readonly')}>Cancel</Button>}
                        <Button variant="contained" sx={{width: SOCIAL_ACCOUNT_BUTTON_WIDTH}} startIcon={<SaveIcon />} onClick={sftpAccount.id ? onUpdate : onCreate}>
                            {sftpAccount.id ? 'Save' : 'Create'}
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default SFTPStorageForm;